// components/DeviceChecker.js
import { useEffect, useState } from 'react';

const DeviceChecker = ({ children }) => {
  const [isAppDevice, setIsAppDevice] = useState(false);

  useEffect(() => {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const deviceParam = urlParams.get('device');

    // If device=app is found, store it in localStorage
    if (deviceParam === 'app') {
      localStorage.setItem('device', 'app');
    }

    // Check localStorage for the device type
    const storedDevice = localStorage.getItem('device');
    if (storedDevice === 'app') {
      setIsAppDevice(true);
    }
  }, []);

  return (
    <>
      {!isAppDevice && children}
    </>
  );
};

export default DeviceChecker;
